var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'team__icon-' + _vm.number},[_c('img',{attrs:{"src":require('@/assets/images/icon-team-' + _vm.number + '.svg'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }